import React from "react";
import Button from "./button";
import Phone from "../assets/icons/phone.svg";
import Email from "../assets/icons/email.svg";
import Qr from "../assets/icons/qr.svg";
import User from "../assets/icons/user.svg";
import { saveVCard, saveVCardAndroid } from "../utils/functions";
import Linkedin from "../assets/icons/linkedin.svg";
import { isAndroid } from "react-device-detect";

export default function Functions({ data }) {
  return (
    <section id="functions">
      <Button
        callback={() => {
          window.location.href = `tel:${data.phone}`;
        }}
        icon={Phone}
        text="Call"
      />
      <Button
        callback={() => {
          window.location.href = `mailto:${data.email}`;
        }}
        icon={Email}
        text="Email"
      />
      {/* {data.linkedinUrl && (
        <Button
          icon={Linkedin}
          text="Linkedin"
          callback={() => {
            window.location.href = `${data.linkedinUrl}`;
          }}
        />
      )} */}
      <Button
        isActive
        callback={() => {
          if (isAndroid) {
            saveVCardAndroid(data);
          } else {
            saveVCard(data);
          }
        }}
        icon={User}
        text="Save"
      />
    </section>
  );
}
